import type { AllowlistField, InvoiceOrBillKind } from "./invoiceBillDisplayDiff.types";

/** Ordered header fields: invoice */
export const INVOICE_HEADER_FIELDS: AllowlistField[] = [
  { key: "customer_name", label: "Customer Name" },
  { key: "invoice_number", label: "Invoice Number" },
  { key: "date", label: "Date" },
  { key: "due_date", label: "Due Date" },
  { key: "currency_symbol", label: "Currency" },
  { key: "exchange_rate", label: "Exchange Rate" },
  { key: "vendor_gstin", label: "Vendor Gstin" },
  { key: "sub_total", label: "Sub Total" },
  { key: "tax_total", label: "Tax total" },
  { key: "total", label: "Total" },
  { key: "tcs_tax_name", label: "Tcs Name" },
  { key: "tcs_tax_percentage", label: "Tcs Tax percentage" },
];

/** Ordered header fields: bill */
export const BILL_HEADER_FIELDS: AllowlistField[] = [
  { key: "vendor_name", label: "Vendor Name" },
  { key: "bill_number", label: "Bill Number" },
  { key: "date", label: "Date" },
  { key: "due_date", label: "Due Date" },
  { key: "currency_symbol", label: "Currency" },
  { key: "exchange_rate", label: "Exchange Rate" },
  { key: "vendor_gstin", label: "Vendor Gstin" },
  { key: "sub_total", label: "Sub Total" },
  { key: "tax_total", label: "Tax total" },
  { key: "total", label: "Total" },
  { key: "tcs_tax_name", label: "Tcs Name" },
  { key: "tcs_tax_percentage", label: "Tcs Tax percentage" },
];

/** Line fields: invoice (no TDS on line per product spec) */
export const INVOICE_LINE_FIELDS: AllowlistField[] = [
  { key: "description", label: "Description" },
  { key: "hsn_or_sac", label: "HSN/SAC Code" },
  { key: "quantity", label: "Quantity" },
  { key: "rate", label: "Rate" },
  { key: "account_name", label: "Account Name" },
  { key: "tax_name", label: "Tax name" },
  { key: "tax_percentage", label: "Tax Percentage" },
  { key: "tax_amount", label: "Tax Amount" },
  { key: "item_total", label: "Total without tax" },
  {
    key: "item_total_inclusive_of_tax",
    label: "Total after adding tax",
  },
];

/** Line fields: bill (includes TDS) */
export const BILL_LINE_FIELDS: AllowlistField[] = [
  { key: "description", label: "Description" },
  { key: "hsn_or_sac", label: "HSN/SAC Code" },
  { key: "quantity", label: "Quantity" },
  { key: "rate", label: "Rate" },
  { key: "account_name", label: "Account Name" },
  { key: "tax_name", label: "Tax name" },
  { key: "tax_percentage", label: "Tax Percentage" },
  { key: "tax_amount", label: "Tax Amount" },
  { key: "tds_tax_name", label: "Tds Tax name" },
  { key: "tds_tax_percentage", label: "Tds Percentage" },
  { key: "item_total", label: "Total without tax" },
  {
    key: "item_total_inclusive_of_tax",
    label: "Total after adding tax",
  },
];

export function getHeaderAllowlist(kind: InvoiceOrBillKind): AllowlistField[] {
  return kind === "invoice" ? INVOICE_HEADER_FIELDS : BILL_HEADER_FIELDS;
}

export function getLineAllowlist(kind: InvoiceOrBillKind): AllowlistField[] {
  return kind === "invoice" ? INVOICE_LINE_FIELDS : BILL_LINE_FIELDS;
}

function fieldKeySet(fields: readonly { key: string }[]): Set<string> {
  return new Set(fields.map((f) => f.key));
}

/** Canonical header keys allowed in `field_changes` / tracked review deltas (invoice). */
export const INVOICE_HEADER_TRACK_KEY_SET = fieldKeySet(INVOICE_HEADER_FIELDS);

/** Canonical header keys allowed in `field_changes` / tracked review deltas (bill). */
export const BILL_HEADER_TRACK_KEY_SET = fieldKeySet(BILL_HEADER_FIELDS);

/** Canonical line-item keys allowed for tracked line-level changes (invoice). */
export const INVOICE_LINE_TRACK_KEY_SET = fieldKeySet(INVOICE_LINE_FIELDS);

/** Canonical line-item keys allowed for tracked line-level changes (bill); includes TDS. */
export const BILL_LINE_TRACK_KEY_SET = fieldKeySet(BILL_LINE_FIELDS);
